import React, {useState, useEffect, useRef} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Link } from 'react-router-dom';
import { Row, Col, Container, Card, CardBody, CardTitle, Modal,  Badge, UncontrolledDropdown } from "reactstrap"
import axios from 'axios';
import * as url from 'helpers/url_helper';
import * as be from 'helpers/backend_helper';
import { Config, TOAST_OPTIONS, formatDate } from 'helpers/backend_helper';
import toastr from "toastr";
import "toastr/build/toastr.min.css";

import { Button,  DropdownToggle,  DropdownMenu,  DropdownItem,  ButtonDropdown, Table} from "reactstrap";
import LoadingOverlay from 'react-loading-overlay';
import BounceLoader from 'react-spinners/BounceLoader'
import Select from "react-select"
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import { useHistory, useParams } from 'react-router-dom';

import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, {Search} from 'react-bootstrap-table2-toolkit';

import paginationFactory, {
    PaginationListStandalone,
    PaginationProvider,
  } from "react-bootstrap-table2-paginator";

    const PayrollDetails = () => {
        const {id} = useParams()
        const [total, setTotal] = useState({
          basicPay: 0,
          grossPay: 0,
          totalAllowances: 0,
          totalDeductions: 0,
          netSalary: 0,
        })
        const history = useHistory();
        toastr.options = TOAST_OPTIONS;
        const [isLoading, setIsLoading] = useState(false)

        const [lineId, setLineId] = useState('')
        const [eName, setEName] = useState('')
        const [eTitle, setETitle] = useState('')
        const [eDept, setEDept] = useState('')
        const [eLocation, setELocation] = useState('')
        const [ePayGrade, setEPayGrade] = useState('')
        const [eBasicPay, setEBasicPay] = useState(0)
        const [eAllowances, setEAllowances] = useState([])
        const [eDeductions, setEDeductions] = useState([])
        const [eNetPay, setENetPay] = useState(0)
        const [eGrossPay, setEGrossPay] = useState(0)
        const [eTotalAllowances, setETotalAllowances] = useState(0)
        const [eTotalDeductions, setETotalDeductions] = useState(0)
 
        const [payrollList, setPayrollList] = useState([])
        const [documentNo, setDocumentNo] = useState('')
        const [payMonth, setPayMonth] = useState('')
        const [createdAt, setCreatedAt] = useState('')
        const [updatedAt, setUpdatedAt] = useState('')
        const [status, setStatus] = useState('Draft')
        const [remark, setRemark] = useState('')
        const [processedByName, setProcessedByName] = useState('')
        const [processedById, setProcessedById] = useState('')
        const [payrollLines, setPayrollLines] = useState([])

        const [sName, setSName] = useState('')
        const [sDept, setSDept] = useState('')
        const [deptList, setDeptList] = useState([])
        const [sJobTitle, setSJobTitle] = useState('')
        const [jobTitleOptions, setJobTitleOptions] = useState([])
        const [sLocation, setSLocation] = useState('')
        const [jobLocationOptions, setJobLocationOptions] = useState([])
        const [sScale, setSScale] = useState('')
        const [scaleList, setScaleList] = useState([])
    
        
        const [userId, setUserId] = useState('')
        const [username, setUsername] = useState('')
        const [isEdit, setIsEdit] = useState(false)

        const [statusOptions, setStatusOptions]     = useState(['Draft', 'Pending Approval', 'Approved', 'Paid'])
        const [modal_payroll_details, setmodal_payroll_details] = useState(false);
        
        const removeBodyCss = () => {
          document.body.classList.add("no_padding");
        }
        const tog_payroll_details = () => {
          setmodal_payroll_details(!modal_payroll_details);
          removeBodyCss();
        }
        
        
        useEffect(() => {
          if (localStorage.getItem("authWTUser")) {
            const obj = JSON.parse(localStorage.getItem("authWTUser"));
            setUserId(obj.id);
            setUsername(obj.username)
          }
          axios.get(url.DEPTS, Config).then((r)=>{ setDeptList(r.data) }).catch((e)=>console.log(e))
          axios.get(url.HRLOCATIONS, Config).then((r)=>{ setJobLocationOptions(r.data);  }).catch((e)=>{  console.log(e); });
          axios.get(url.TITLES, Config).then((r)=>{ setJobTitleOptions(r.data); }).catch((e)=>console.log(e))
          axios.get(url.HRPAYSCALES, Config).then((r)=>{ setScaleList(r.data); }).catch((e)=>console.log(e))
          handleFilterData() 
        },[]);

        const handleClickDelete = async () =>{
          const data = {
            id : be.decryptId(id),
            action: 'delete'
          }
          try{
            setIsLoading(true)
            const r = await axios.post(url.HRPAYROLL, JSON.stringify(data), Config)
            if(r.data.status == '1'){
              toastr.success(r.data.message)
              history.push('/payroll')
            }else{
              toastr.error(r.data.message)
            }
          }catch(e){
            console.log(e)
          }finally{
            setIsLoading(false)
          }
        }
        const handleGeneratePayslip = async (line) =>{
          try {
            setIsLoading(true)
            const r = await axios.post(url.HRPRINTPAYSLIPS, JSON.stringify({lineId:line}), Config)
            const urlx = url.APACHE_URL + r.data.slip
            const response = await axios({url: urlx, method: 'GET', responseType: 'blob'})
            const urln = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = urln;
            link.setAttribute('download', `Payslip_${payMonth}.pdf`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(urln)
          } catch(e){
            console.log(e)
          } finally {
            setIsLoading(false)
          }
        }
        const handleExportToPDF = async () =>{
          try {
            setIsLoading(true)
            const r = await axios.post(url.HRPRINTPAYROLLPDF, JSON.stringify({payroll_id:be.decryptId(id)}), Config)
            if(r.data.status == '1'){ toastr.success(r.data.message); }else{   toastr.error(r.data.message); }
            const urlx = url.APACHE_URL + r.data.report
            const response = await axios({url: urlx, method: 'GET', responseType: 'blob'})
            const urln = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = urln;
            link.setAttribute('download', `${payMonth}_PAYROLL.pdf`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(urln)
          } catch(e){
            console.log(e)
          } finally {
            setIsLoading(false)
          }
        }
        const handleExportToExcel = async () =>{
          try {
            setIsLoading(true)
            const r = await axios.post(url.HRPRINTPAYROLL, JSON.stringify({payroll_id:be.decryptId(id)}), Config)
            if(r.data.status == '1'){ toastr.success(r.data.message); }else{   toastr.error(r.data.message); }
            const urlx = url.APACHE_URL + "attach/payroll_output.xlsx"
            const response = await axios({url: urlx, method: 'GET', responseType: 'blob'})
            const urln = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = urln;
            link.setAttribute('download', `${payMonth}_PAYROLL.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(urln)
          } catch(e){
            console.log(e)
          } finally {
            setIsLoading(false)
          }
        }
        const handleFilterData = async () =>{
          const data = {
            payroll_id          : be.decryptId(id),
            employee_name       : sName,
            dept_id             : sDept,
            title_id            : sJobTitle,
            location_id         : sLocation,
            scale_id            : sScale,
            action              : 'filter'
         }
         try {
          setIsLoading(true)
          const r = await axios.post(url.HRPAYROLLLINE, JSON.stringify(data), Config)
          setDocumentNo(r.data.payrollDetails.document_no)
          setPayMonth(r.data.payrollDetails.pay_month)
          setCreatedAt(r.data.payrollDetails.created_at)
          setUpdatedAt(r.data.payrollDetails.updated_at)
          setStatus(r.data.payrollDetails.status)
          setRemark(r.data.payrollDetails.remarks)
          setProcessedByName(r.data.payrollDetails.user_name)
          setProcessedById(r.data.payrollDetails.processed_by)
          setPayrollLines(r.data.payrollLines)
          let totalfigures = r.data.payrollLines.reduce(
            (acc, line) => {
              acc.basicPay += parseFloat(line.basicPay);
              acc.grossPay += parseFloat(line.grossPay);
              acc.totalAllowances += parseFloat(line.totalAllowances);
              acc.totalDeductions += parseFloat(line.totalDeductions);
              acc.netSalary += parseFloat(line.netSalary);
              return acc;
            },
            {
              basicPay: 0,
              grossPay: 0,
              totalAllowances: 0,
              totalDeductions: 0,
              netSalary: 0,
            }
          );
          setTotal(totalfigures)
         } catch (e) {
          console.log(e)
         } finally {
          setIsLoading(false)
         }
        }

        const pageOptions = {
          sizePerPage: 10000,
          totalSize: payrollList.length,
          custom: true,
        }
        var node = useRef();
              
        const columns = [
        {
          dataField: 'employeeNo',
          text: 'No',
          sort: true
        },
        {
          dataField: 'employeeName',
          text: 'Name',
          sort: true
        },
        {
          dataField: 'title',
          text: 'Title',
          sort: true
        },
        {
          dataField: 'department',
          text: 'Department',
          sort: true
        },
        {
          dataField: 'location',
          text: 'Location',
          sort: true
        },
        {
          dataField: 'payScale',
          text: 'Grade',
          sort: true
        },
        {
          dataField: 'basicPay',
          text: 'Basic Pay',
          sort: true,
          formatter: currencyFormatter,
          headerAlign: 'right'
        }, 
        {
          dataField: 'totalAllowances',
          text: 'Allowances',
          sort: true,
          formatter: currencyFormatter,
          headerAlign: 'right'
        }, 
        {
          dataField: 'totalDeductions',
          text: 'Deductions',
          sort: true,
          formatter: currencyFormatter,
          headerAlign: 'right'
        }, 
        {
          dataField: 'grossPay',
          text: 'Gross Pay',
          sort: true,
          formatter: currencyFormatter,
          headerAlign: 'right'
        }, 
        {
          dataField: 'netSalary',
          text: 'Net Pay',
          sort: true,
          formatter: currencyFormatter,
          headerAlign: 'right'
        }, 
        {
          dataField: "action",
          isDummyField: true,
          text: "",
          formatter: actionFormatter
        }];

        const defaultSorted = [{
          dataField: 'department',
          order: 'desc'
        }];
        function currencyFormatter(cellContent, row) {
          const formatted = new Intl.NumberFormat().format(cellContent);
          return (
            <div style={{ textAlign: 'right' }}>
              {formatted}
            </div>
          );
        }
 
        function actionFormatter(cellContent, row){
          return(
            <Button
                  type="button"
                  color="info"
                  className="btn-sm btn-rounded"
                  onClick={()=>{ 
                      tog_payroll_details()
                      setLineId(row.lineId)
                      setEName(row.employeeName)
                      setETitle(row.title)
                      setEDept(row.department)
                      setELocation(row.location)
                      setEPayGrade(row.payScale)
                      setEBasicPay(row.basicPay)
                      setEGrossPay(row.grossPay)
                      setEAllowances(row.additions)
                      setEDeductions(row.deductions)
                      setENetPay(row.netSalary)
                      setETotalAllowances(row.totalAllowances)
                      setETotalDeductions(row.totalDeductions)
                    }
                  }
                >
                  Details
            </Button>
          )
        }
        function statusFormatter(cellContent, row) {
          if (cellContent == "Closed") {
            return (
              <div>
                  <Badge className="me-2 bg-success">{ cellContent }</Badge>
              </div>
            );
          }else if(cellContent == "Pending Approval"){
            return (
              <div>
                  <Badge className="me-2 bg-warning">{cellContent}</Badge>
              </div>
            );
          }else{
            return (
              <div>
                  <Badge className="me-2 bg-danger">{ cellContent }</Badge>
              </div>
            );
          }
        }

        
        return (
            <>
              <LoadingOverlay
                active={isLoading}
                spinner={<BounceLoader />}
                text='Please wait...'
                >
                <div className="page-content">
                    <MetaTags>
                    <title>Payroll Details | {url.COMPANY}</title>
                    </MetaTags>
                    <Container fluid={true}>

                                <Modal isOpen={modal_payroll_details} toggle={() => { tog_payroll_details(); }}  size="l" centered  backdrop={'static'}  >
                                <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{eName} Pay Details for {payMonth}</h5>
                                    <button type="button"  onClick={() => { setmodal_payroll_details(false);  }}  className="close" data-dismiss="modal"aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <Row>
                                     
                                      <Col md={12}>
                                        <Table className="table table-striped table-sm me-2">
                                              <thead>
                                                <tr>
                                                  <th>Name</th>
                                                  <th style={{ textAlign: "right" }}>{eName}</th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                <tr>
                                                  <td>Title</td>
                                                  <td style={{ textAlign: "right" }}>{eTitle}</td>
                                                </tr>
                                                <tr>
                                                  <td>Department</td>
                                                  <td style={{ textAlign: "right" }}>{eDept}</td>
                                                </tr>
                                                <tr>
                                                  <td>Location</td>
                                                  <td style={{ textAlign: "right" }}>{eLocation}</td>
                                                </tr>
                                                <tr>
                                                  <td>Pay Grade</td>
                                                  <td style={{ textAlign: "right" }}>{ePayGrade}</td>
                                                </tr>
                                                <tr>
                                                  <td>Pay Month</td>
                                                  <td style={{ textAlign: "right" }}>{payMonth}</td>
                                                </tr>
                                            </tbody>
                                            </Table>
                                            <Table className="table table-striped table-sm me-2">
                                              <thead>
                                                <tr>
                                                  <th>Additions</th>
                                                  <th style={{ textAlign: "right" }}></th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                              {eAllowances.map((a,k)=>(
                                                <tr key={k}>
                                                  <td>{a.adjustment_name}</td>
                                                  <td style={{ textAlign: "right" }}>{Number(a.calculated_amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                                                </tr>
                                              ))}
                                                <tr>
                                                  <th></th>
                                                  <th style={{ textAlign: "right" }}>{Number(eTotalAllowances).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</th>
                                                </tr>
                                                
                                            </tbody>
                                            </Table>
                                      
                                            <Table className="table table-striped table-sm me-2">
                                              <thead>
                                                <tr>
                                                  <th>Deductions</th>
                                                  <th style={{ textAlign: "right" }}></th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                              {eDeductions.map((a,k)=>(
                                                <tr key={k}>
                                                  <td>{a.adjustment_name}</td>
                                                  <td style={{ textAlign: "right" }}>{Number(a.calculated_amount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                                                </tr>
                                              ))}
                                              <tr>
                                                  <th></th>
                                                  <th style={{ textAlign: "right" }}>{Number(eTotalDeductions).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</th>
                                                </tr>
                                            </tbody>
                                            </Table>
                                      
                                            <Table className="table table-striped table-sm me-2">
                                              <thead>
                                                <tr>
                                                  <th>Summary</th>
                                                  <th style={{ textAlign: "right" }}></th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                <tr>
                                                  <th>Basic Pay</th>
                                                  <th style={{ textAlign: "right" }}>{Number(eBasicPay).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</th>
                                                </tr>
                                                <tr>
                                                  <th>Gross Pay</th>
                                                  <th style={{ textAlign: "right" }}>{Number(eGrossPay).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</th>
                                                </tr>
                                             
                                              <tr>
                                                  <th>Net Pay</th>
                                                  <th style={{ textAlign: "right" }}>{Number(eNetPay).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</th>
                                                </tr>
                                            </tbody>
                                            </Table>
                                      </Col>
                                  
                                    </Row>
                                </div>
                                <div className="modal-footer">
                                <button type="button" className="btn btn-warning" onClick={()=>{handleGeneratePayslip(lineId)}} >Generate Payslip...</button></div>
                                </Modal> 

                            <Row>
                                      
                            <Col lg="12">
                            <Card>
                            <h5 className="card-header bg-transparent border-bottom text-uppercase">Filter</h5>
                                <CardBody>
                                

                                                <Row className="justify-content-center mb-1">
                                                      <Col md={2}>
                                                          <div className="mb-3">
                                                              <label>Name</label>
                                                              <input type='text' className="form-control form-control-sm" value={sName} onChange={(e)=>setSName(e.target.value)} />
                                                              
                                                          </div>
                                                      </Col>   
                                                      <Col md={2}>
                                                          <div className="mb-3">
                                                              <label>Pay Grade/Scale</label>
                                                              <select className="form-select form-select-sm" value={sScale} onChange={(e)=>setSScale(e.target.value)}>
                                                                    <option>All</option>
                                                                    {scaleList.map((d,k)=>(
                                                                        <option key={k} value={d.id}>{d.name}</option>
                                                                    ))}
                                                                </select>
                                                              
                                                          </div>
                                                      </Col>           
                                                      <Col md={2}>
                                                          <div className="mb-3">
                                                              <label>Department</label>
                                                              <select className="form-select form-select-sm" value={sDept} onChange={(e)=>setSDept(e.target.value)}>
                                                              <option value="">All</option>
                                                                {(deptList || []).map((d,k)=>(
                                                                  <option key={k} value={d.id}>{d.name}</option>
                                                                ))}
                                                              </select>
                                                          </div>
                                                      </Col>
                                                      <Col md={2}>
                                                          <div className="mb-3">
                                                              <label>Title</label>
                                                              <select className="form-select form-select-sm" value={sJobTitle} onChange={(e)=>setSJobTitle(e.target.value)}>
                                                                  <option value=''>All</option>
                                                                    {(jobTitleOptions || []).map((t,k)=>(
                                                                      <option key={k} value={t.id}>{t.title}</option>
                                                                    ))}
                                                              </select>
                                                          </div>
                                                      </Col>
                                                      <Col md={2}>
                                                          <div className="mb-3">
                                                              <label>Location</label>
                                                              <select className="form-select form-select-sm" value={sLocation} onChange={(e)=>setSLocation(e.target.value)}>
                                                                  <option value="">All</option>
                                                                  {(jobLocationOptions || []).map((d,k)=>(
                                                                    <option key={k} value={d.id}>{d.name}</option>
                                                                  ))}
                                                              </select>
                                                          </div>
                                                      </Col>                                 
                                                </Row>
                                         
                             
                                                <Row  className="justify-content-center mb-2">
                                                <Col lg={2} className='mb-2'> 
                                                  <div className="d-grid gap-2">
                                                      <Button
                                                        color='primary'
                                                        className="btn btn-sm"
                                                        onClick={()=>{handleFilterData()}}
                                                      >
                                                        <i className="mdi mdi-magnify me-1" />
                                                        Search
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                  <Col lg={2} className='mb-2'> 
                                                      <div className="d-grid gap-2">
                                                        <Button
                                                          color='secondary'
                                                          className="btn btn-sm"
                                                          onClick={()=>{handleExportToExcel()}}
                                                          
                                                        >
                                                          <i className="mdi mdi-export me-1" />
                                                          Export To Excel
                                                        </Button>
                                                      </div>
                                                    </Col>
                                                    <Col lg={2} className='mb-2'> 
                                                      <div className="d-grid gap-2">
                                                        <Button
                                                          color='secondary'
                                                          className="btn btn-sm"
                                                          onClick={()=>{handleExportToPDF()}}
                                                          
                                                        >
                                                          <i className="mdi mdi-export me-1" />
                                                          Export To PDF
                                                        </Button>
                                                      </div>
                                                    </Col>
                                                  {status == 'Pending Approval' && (
                                                    <>
                                                    {(userId == processedById) && (
                                                    <Col lg={2} className='mb-2'> 
                                                      <div className="d-grid gap-2">
                                                        <Button
                                                          color='success'
                                                          className="btn btn-sm"
                                                          //onClick={()=>{handleClickApprove()}}
                                                          
                                                        >
                                                          <i className="mdi mdi-check-all me-1" />
                                                          Approve Payroll
                                                        </Button>
                                                      </div>
                                                    </Col>
                                                    )}
                                                     {(userId == processedById) && (
                                                    <Col lg={2} className='mb-2'> 
                                                      <div className="d-grid gap-2">
                                                        <Button
                                                          color='success'
                                                          className="btn btn-sm"
                                                          //onClick={()=>{handleClickCancelApproval()}}
                                                          
                                                        >
                                                          <i className="mdi mdi-check-all me-1" />
                                                          Cancel Approval Request
                                                        </Button>
                                                      </div>
                                                    </Col>
                                                    )}
                                                    </>
                                                  )}
                                                  {status == 'Open' && (
                                                  <>
                                                    {(userId == processedById) && (
                                                      <Col lg={2} className='mb-2'> 
                                                        <div className="d-grid gap-2">
                                                          <Button
                                                            color='warning'
                                                            className="btn btn-sm"
                                                            // onClick={() => handleClickSendForApproval()}
                                                          >
                                                            <i className="mdi mdi-check-all me-1" />
                                                            Send for Approval
                                                          </Button>
                                                        </div>
                                                      </Col>
                                                    )}
                                                    
                                                    <Col lg={2} className='mb-2'> 
                                                      <div className="d-grid gap-2">
                                                        <Button
                                                          color='danger'
                                                          className="btn btn-sm"
                                                          onClick={handleClickDelete}
                                                        >
                                                          <i className="mdi mdi-trash-can me-1" />
                                                          Delete Payroll
                                                        </Button>
                                                      </div>
                                                    </Col>
                                                  </>
                                                )}
                                                </Row>
                                                </CardBody>
                                                </Card>
                                                <Card>
                            <h5 className="card-header bg-transparent border-bottom text-uppercase">Payroll Details</h5>
                                <CardBody>
                                
                                                <Row className="justify-content-center mb-1">
                                                  <Col md={12}>
                                                  <Table className="table table-striped">
                                                      <tbody>
                                                        <tr>
                                                          <th>Employees:</th>
                                                          <th style={{ textAlign: "right" }}>{payrollLines.length}</th>
                                                          <th>May Month:</th>
                                                          <th style={{ textAlign: "right" }}>{payMonth}</th>
                                                          <th>Document No:</th>
                                                          <td style={{ textAlign: "right" }}>{documentNo}</td>
                                                          <th>Processed By:</th>
                                                          <td style={{ textAlign: "right" }}>{processedByName}</td>
                                                        </tr>
                                                        <tr>
                                                          <th>Status:</th>
                                                          <th style={{ textAlign: "right" }}>{status}</th>
                                                          <th>Created at:</th>
                                                          <td style={{ textAlign: "right" }}>{createdAt}</td>
                                                          <th>Last Updated at:</th>
                                                          <td style={{ textAlign: "right" }}>{updatedAt}</td>
                                                        </tr>
                                                        
                                                        <tr>
                                                          <th>Total Allowances:</th>
                                                          <th style={{ textAlign: "right" }}>{Number(total.totalAllowances).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</th>
                                                          <th>Total Deductions:</th>
                                                          <th style={{ textAlign: "right" }}>{Number(total.totalDeductions).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</th>
                                                          <th>Total Net Pay:</th>
                                                          <th style={{ textAlign: "right" }}>{Number(total.netSalary).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</th> 
                                                          <th>Total Gross Pay:</th>
                                                          <th style={{ textAlign: "right" }}>{Number(total.grossPay).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</th>
                                                        </tr>
                                                       
                                                      </tbody>
                                                    </Table>
                                                  </Col>

                                                </Row>
                                         
                             
                                                </CardBody>
                                                </Card>

                                                <Card>
                                                <h6 className="card-header bg-transparent border-bottom text-uppercase">Employees ({payrollLines.length})</h6>
                                                  <CardBody>

                                                                                             
                                {(payrollLines.length > 0) && (
                                    <PaginationProvider
                                    pagination={paginationFactory(pageOptions)}
                                    keyField="lineId"
                                    columns={columns}
                                    data={payrollLines}
                                    >
                                    {({ paginationProps, paginationTableProps }) => (
                                    <ToolkitProvider
                                      keyField="lineId"
                                      data={ payrollLines }
                                      columns={ columns }
                                    >
                                      { toolkitProps => (
                                          <React.Fragment>
                              
                                            <Row>
                                              <Col xl="12">
                                                
                                              <div className="table-responsive">
                                                <BootstrapTable 
                                                  
                                                  keyField='lineId' 
                                                  data={ payrollLines } 
                                                  columns={ columns } 
                                                  striped
                                                  hover
                                                  condensed
                                                  bordered={ false }
                                                  noDataIndication="No Records" 
                                                  defaultSorted={ defaultSorted }
                                                  classes={ "table table-sm align-middle table-nowrap table-check" }
                                                  style={{ backgroundColor: 'white' }}
                                                    {...toolkitProps.baseProps}
                                                    {...paginationTableProps}
                                                  ref={node}
                                                  />
                                                  </div>
                                            
                                            </Col>
                                            </Row>
                                            <Row className="align-items-md-center mt-30">
                                              <Col className="pagination pagination-rounded justify-content-end mb-2 inner-custom-pagination">
                                                <PaginationListStandalone
                                                  {...paginationProps}
                                                />
                                              </Col>
                                            </Row>
                                            </React.Fragment>
                                            
                                      )
                                    }
                                    </ToolkitProvider>
                                    )}
                                    </PaginationProvider>
                                    )}
                                    {((payrollLines || []).length < 1) && (
                                    <div className="text-center">
                                      <div className="mb-4">
                                      <i className="mdi mdi-flask-empty-minus-outline text-danger display-4" />
                                      </div>
                                      <div>
                                      { isLoading ? <h5>Please Wait...</h5> : <h5>No data</h5> }
                                      <p className="text-muted">
                                              
                                      </p>
                                      </div>
                                      <div className="text-center mt-4">
                                     
                                    </div>
                                    </div>
                                    

                                    )}


                                </CardBody>
                            </Card>
                            </Col>

                           
                        </Row>

                        
                           

                    </Container>
                </div>
                </LoadingOverlay>
            </>
        );
    }

export default PayrollDetails;